import axios from "axios"
import { getEnv } from "../../../../../../utils/env"
import { PdfGeneratorResultDataType } from "../types"

const DOC_RAPTOR_TEST_PROJECT_IDS = [
  "mp-ready-staging",
  "mp-ready-pre-production",
  "workkeys-project-staging",
  "workkeys-project-preprod"
]

export type ConvertHtmlToPdfBlobOptions = {
  htmlDocument: string
  fileName: string
  onDownloadProgress?: (progressEvent: {
    loaded: number
    total?: number
  }) => void
}

export const convertHtmlToPdfBlob = async (
  args: ConvertHtmlToPdfBlobOptions
): Promise<PdfGeneratorResultDataType> => {
  const { htmlDocument, fileName, onDownloadProgress } = args

  const apiKey = getEnv("DOC_RAPTOR_API_KEY")

  if (!apiKey) {
    throw new Error("VITE_DOC_RAPTOR_API_KEY is not configured")
  }

  const projectId = getEnv("PROJECT_ID")
  const isTestDocument = DOC_RAPTOR_TEST_PROJECT_IDS.includes(projectId)

  const response = await axios({
    method: "post",
    url: "https://docraptor.com/docs",
    headers: {
      "Content-Type": "application/json"
    },
    responseType: "blob",
    data: {
      user_credentials: apiKey,
      doc: {
        document_content: htmlDocument,
        type: "pdf",
        javascript: true,
        test: isTestDocument
      }
    },
    onDownloadProgress
  })

  const blob = new Blob([response.data], { type: "application/pdf" })
  const url = URL.createObjectURL(blob)

  return { blob, url, fileName }
}
